import React from 'react';
import cn from 'classnames';
import classes from './toggle.module.scss';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const CubbyFilter = ({
  onToggleSwitch,
  sortByName,
  ascendingCheck,
  showClosedChecks,
}) => {
  const cubbyFilter = [
    {
      label1: FLABEL().HEADER_SORTNAME,
      label2: FLABEL().HEADER_SORTTIME,
      key: 'nameTimeSort',
      id: '1',
    },
    { label1: FLABEL().HEADER_ASC, label2: FLABEL().HEADER_DEC, key: 'sortByAscDes', id: '2' },
    { label1: FLABEL().HEADER_CLOSED, label2: FLABEL().HEADER_ALL, key: 'sortByCloasedAll', id: '3' },
  ];
  return (
    <div className={cn(classes.toggleContainer, 'd-flex')}>
      {cubbyFilter.map(item => {
        const isChecked =
          item.key === 'nameTimeSort'
            ? sortByName
            : item.key === 'sortByAscDes'
            ? ascendingCheck
            : item.key === 'sortByCloasedAll'
            ? showClosedChecks
            : false;
        return (
          <div key={item.key} className={cn(classes.toggleWrapper)}>
            <span className={cn(classes.label, isChecked ? 'fw-600' : 'fw-400')}>{item.label1}</span>

            <label className={cn(classes.toggle, 'm-0')} htmlFor={item.id}>
              <input
                id={item.id}
                type="checkbox"
                className={classes.checkbox}
                checked={!isChecked}
                onChange={() => onToggleSwitch(item.key)}
              />
              <span className={cn(classes.slider)}></span>
            </label>

            <span className={cn(classes.label, !isChecked ? 'fw-600' : 'fw-400')}>{item.label2}</span>
          </div>
        );
      })}
    </div>
  );
};

export default CubbyFilter;
